import {AbstractModel} from '../abstract-model';
import {AvailableDomain} from './available-domain';
import {StaticPageStatus} from '../../constants/static-page-status';
import {Scope} from '../../constants/scope';
import {User} from '../user';
import {PageType} from '../page-type';
import {Product} from '../product';
import {environment} from '../../../environments/environment';

export class StaticPage extends AbstractModel {
  id!: number;
  name: string = '';
  domain: AvailableDomain | null = null;
  pageType: PageType | null = null;
  product: Product | null = null;
  slug: string | null = null;
  locale: string | null = null;
  htmlContent: string | null = null;
  status: StaticPageStatus = StaticPageStatus.PENDING;
  user: User | null = null;
  scope: Scope = Scope.PUBLIC;
  publishedAt: Date | null = null;
  updatedAt!: Date;
  createdAt!: Date;

  override deserialize(input: any): this {
    super.deserialize(input);

    if (input.domain) {
      this.domain = new AvailableDomain().deserialize(input.domain);
    }

    if (input.pageType) {
      this.pageType = new PageType().deserialize(input.pageType);
    }

    if (input.product) {
      this.product = new Product().deserialize(input.product);
    }

    if (input.user) {
      this.user = new User().deserialize(input.user);
    }

    return this;
  }

  override toString(): string {
    return this.name;
  }

  getLink(): string {
    if (this.domain) {
      return 'https://' + this.domain.domain + this.domain.getSlug() + this.slug;
    } else {
      return '';
    }
  }

  isPublished(): boolean {
    return this.publishedAt !== null && this.publishedAt <= new Date();
  }
}
